import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import placeholderImage from '../../assets/placeholder.jpg';
import DiscountBadge from './DiscountBadge';
import ColorSwatch from './ColorSwatch';
import ProductListPrice from './ProductListPrice';
import ProductItem from "../ProductItem";

export default function Loopingproduct(props) {
    const ServicesRef = useRef(null);
    const wishlistItems = useSelector(state => state?.cart?.wishlistItems);
    const filterData = props.products;



    return (
        <>

            {Array.isArray(filterData) &&
                <>
                    {filterData?.map((dt) => {
                        const localId = localStorage.getItem("mylocalid");
                        const itemProps = dt?._id === localId ? { ref: ServicesRef } : {};
                        const isInWishlist = wishlistItems?.some((item) => item?._id === dt?._id);

                        const variantData = dt?.variants?.[0];

                        const priceDetails = variantData?.sizes?.[0]?.skus[0] || {};
                        const regularPrice = priceDetails?.price || 0;
                        const salePrice = priceDetails?.discountPrice;


                        const discount =
                            salePrice > 0 && regularPrice > 0
                                ? Math.round(((regularPrice - salePrice) * 100) / regularPrice)
                                : null;


                        const ImageUrl = process.env.REACT_APP_IMAGE_URL + variantData?.newImagesUrl?.[0];

                        return (
                            <ProductItem
                                item={dt}
                                key={dt?._id}
                                addItemToWishlist={props.addItemToWishlist}
                            />
                        );
                    }
                    )}
                </>
            }



        </>
    )
}
